import type { SyncHealthStatus } from "./types";

export const SYNC_HEALTH_STATUSES: SyncHealthStatus[] = [
  "HEALTHY",
  "WARNING",
  "CRITICAL",
  "NEVER_SYNCED",
  "DISCONNECTED",
];

export const STATUS_COLOR: Record<SyncHealthStatus, string> = {
  HEALTHY: "bg-green-100 text-green-800",
  WARNING: "bg-yellow-100 text-yellow-800",
  CRITICAL: "bg-red-100 text-red-800",
  NEVER_SYNCED: "bg-gray-100 text-gray-600",
  DISCONNECTED: "bg-gray-100 text-gray-500",
};

export const STAT_CARD_COLOR: Record<string, string> = {
  healthy: "text-green-600",
  warning: "text-yellow-600",
  critical: "text-red-600",
  neverSynced: "text-gray-500",
  disconnected: "text-gray-400",
};

export const PROVIDERS = ["APPLE_HEALTH", "GOOGLE_FIT"] as const;

export const POLL_INTERVAL_MS = 30_000;
